/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: root.paths.ts
 * Project: mle-client
 * Committed last: 2021/10/25 @ 1138
 * ---
 */

export enum RootPaths {
  DASHBOARD = '/dashboard',
  ROOT = '/',
  FORGOT_PASSWORD = '/password-forgot',
  RESET_PASSWORD_BY_TOKEN = '/reset-password/:token'
}
